import { useContext } from 'react'
import { DataContext } from '../context/DataContext'
import { Components, GeneralModules, RiskManagementModules } from '../api/schemas/schema'

export const useHasModule = () => {
   const { state } = useContext(DataContext)
   const modules = state.organisation?.modules ?? []

   const checkAccess = (allowed: (Components | GeneralModules | RiskManagementModules)[]) => {
      if (!modules || modules.length === 0) return false
      return modules.some((m) => {
         if (!m.isActivated) return false

         // Explicit null/undefined checks to handle '0' enum values
         const hasGeneral = m.generalModule !== null && m.generalModule !== undefined
         const hasComponent = m.component !== null && m.component !== undefined
         const hasRisk = m.riskManagementModule !== null && m.riskManagementModule !== undefined

         return (
            (hasGeneral && allowed.includes(m.generalModule)) ||
            (hasComponent && allowed.includes(m.component)) ||
            (hasRisk && allowed.includes(m.riskManagementModule))
         )
      })
   }

   return { checkAccess }
}
